import { render } from "./DropdownSelect.vue?vue&type=template&id=ac096d18&scoped=true"
import script from "./DropdownSelect.vue?vue&type=script&lang=js"
export * from "./DropdownSelect.vue?vue&type=script&lang=js"

import "./DropdownSelect.vue?vue&type=style&index=0&id=ac096d18&lang=scss&scoped=true"

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac096d18"]])

export default __exports__